module.exports = __webpack_public_path__ + "static/img/gqpx.5eb72dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jianjie/gqpx.png
// module id = psBu
// module chunks = 171